module.exports = __webpack_public_path__ + "static/sorrisoBistro-0b50d273a50936f390500b9f4961da2d.png";